import './MultiImageUpload.css';

/**
 * @typedef {Object} ImageObject
 * @property {File} [file] - For new uploads
 * @property {string} [preview] - For new uploads preview
 * @property {string} [data] - For existing images base64
 * @property {string} [contentType] - For existing images mime type
 * @property {boolean} isNew - Flag to differentiate
 */

const MultiImageUpload = ({ images = [], onChange, required = true }) => {
    // Helper to validate image object
    const isValidImage = (image) => {
        if (image.isNew) {
            return image.file && image.preview;
        }
        return image.data && image.contentType;
    };

    // Get valid image source
    const getImageSrc = (image) => {
        if (!isValidImage(image)) {
            console.error('Invalid image object:', image);
            return '';
        }
        return image.isNew 
            ? image.preview 
            : `data:${image.contentType};base64,${image.data}`;
    };

    const handleFileChange = (e) => {
        const files = e?.target?.files;
        if (!files || files.length === 0) return;
        
        const newImages = Array.from(files).map(file => ({
            file,
            isNew: true,
            preview: URL.createObjectURL(file)
        }));
        
        onChange([...images, ...newImages]);
    };

    const handleRemove = (index) => {
        const newImages = images.filter((_, i) => i !== index);
        onChange(newImages);
    }

    return (
        <div className="image-upload-container">
            <div className="image-grid">
                {Array.isArray(images) && images.map((image, index) => (
                    <div key={index} className="image-preview">
                        <img 
                            className='image-preview-img'
                            src={getImageSrc(image)}
                            alt={`Preview ${index + 1}`}
                            onError={(e) => {
                                console.error('Image load error:', image);
                                e.target.src = ''; // Clear invalid source
                            }}
                        />
                        <button 
                            type="button" 
                            onClick={() => handleRemove(index)}
                            className="remove-btn"
                        >×</button>
                    </div>
                ))}
            </div>
            <input 
                type="file" 
                className="form-control file-input" 
                id="images" 
                name="images" 
                multiple 
                onChange={handleFileChange} 
                accept="image/*"
                required={required}
            />
        </div>
    );
};

export default MultiImageUpload;